"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopper = require("react-popper");

var _reactTransitionGroup = require("react-transition-group");

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A tooltip component.
 */
var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.state = {
      isVisible: false
    };
    _this.clickActive = false;
    _this._handleClick = _this._handleClick.bind(_assertThisInitialized(_this));
    _this._handleFocus = _this._handleFocus.bind(_assertThisInitialized(_this));
    _this._handleBlur = _this._handleBlur.bind(_assertThisInitialized(_this));
    _this._handleMouseEnter = _this._handleMouseEnter.bind(_assertThisInitialized(_this));
    _this._handleMouseLeave = _this._handleMouseLeave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tooltip, [{
    key: "toggleTouchOutsideEvent",
    value: function toggleTouchOutsideEvent(enabled) {
      if (enabled) {
        document.addEventListener('touchstart', this._handleBlur);
      } else {
        document.removeEventListener('touchstart', this._handleBlur);
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        isVisible: true
      });
      this.toggleTouchOutsideEvent(true);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        isVisible: false
      });
      this.toggleTouchOutsideEvent(false);
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
        this.clickActive = true;
        this.show();
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      this.show();
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      this.clickActive = false;
      this.hide();
    }
  }, {
    key: "_handleMouseEnter",
    value: function _handleMouseEnter() {
      if (this.props.openOnHover && !this.clickActive) {
        this.show();
      }
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave() {
      if (this.props.openOnHover && !this.clickActive) {
        this.hide();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isVisible = this.state.isVisible;
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          label = _this$props.label,
          children = _this$props.children,
          placement = _this$props.placement,
          cssModule = _this$props.cssModule;
      var containerClasses = (0, _mapToCssModules.default)((0, _classnames.default)(className, 'tooltip-container'), cssModule);
      var tooltipClasses = (0, _mapToCssModules.default)((0, _classnames.default)('tooltip', 'tooltip-anim'), cssModule);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, null, function (_ref) {
        var ref = _ref.ref;
        return /*#__PURE__*/_react.default.createElement("button", {
          ref: ref,
          type: "button",
          "aria-describedby": id,
          className: (0, _mapToCssModules.default)('tooltip-btn', cssModule),
          onClick: _this2._handleClick,
          onFocus: _this2._handleFocus,
          onBlur: _this2._handleBlur,
          onMouseEnter: _this2._handleMouseEnter,
          onMouseLeave: _this2._handleMouseLeave,
          "aria-expanded": isVisible
        }, /*#__PURE__*/_react.default.createElement("span", null, label));
      }), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        in: isVisible,
        timeout: 300,
        classNames: "tooltip-anim",
        appear: true,
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
        innerRef: function innerRef(n) {
          _this2.popper = n;
        },
        placement: placement,
        eventsEnabled: false,
        modifiers: {
          offset: {
            offset: '0, 15'
          },
          preventOverflow: {
            padding: 10
          }
        }
      }, function (_ref2) {
        var ref = _ref2.ref,
            style = _ref2.style,
            placement = _ref2.placement,
            arrowProps = _ref2.arrowProps;
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: ref,
          style: style,
          "data-placement": placement,
          className: tooltipClasses,
          role: "tooltip"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "tooltip-anim-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _mapToCssModules.default)('tooltip-content', cssModule),
          id: id
        }, children), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _mapToCssModules.default)('tooltip-arrow', cssModule),
          ref: arrowProps.ref,
          style: arrowProps.style
        })));
      }))));
    }
  }]);

  return Tooltip;
}(_react.default.Component);

Tooltip.defaultProps = {
  className: undefined,
  label: 'Tooltip',
  children: undefined,
  placement: 'top',
  openOnHover: true,
  cssModule: undefined
};
Tooltip.propTypes = {
  id: _propTypes.default.string.isRequired,

  /**
   * Will be passed through to the tooltip container
   */
  className: _propTypes.default.string,

  /**
   * The text of the tooltip button
   */
  label: _propTypes.default.string,

  /**
   * The tooltip's content
   */
  children: _propTypes.default.node,

  /**
   * The position that the tooltip should appear relative to the button.
   */
  placement: _propTypes.default.oneOf(['top', 'bottom']),

  /**
   * If true, the tooltip will open on mouse over
   */
  openOnHover: _propTypes.default.bool,
  cssModule: _propTypes.default.object
};
var _default = Tooltip;
exports.default = _default;
//# sourceMappingURL=Tooltip.js.map